import dayjs, { type Dayjs } from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

/**
 * SN-8310 — a bill's due date names a CALENDAR DAY, stored as midnight UTC (an
 * installment's date, custom or periodic, and a deposit capped at the day
 * registration closes). Read in the viewer's zone, Oct 15 00:00 UTC is Oct 14
 * for anyone west of UTC: the payments drawer showed every payment a day early
 * and flagged it overdue on the day it was actually due.
 *
 * Returns the day as Y-m-d, read in UTC.
 */
export const billDueDay = (dueDate: string): string =>
  dayjs.utc(dueDate).format('YYYY-MM-DD')

/** The bill's due day is before today (the viewer's calendar day). */
export const isPastDueDay = (dueDate: string, now: Dayjs = dayjs()): boolean =>
  billDueDay(dueDate) < now.format('YYYY-MM-DD')
